export default {
  rateCalculator: {
    table: {
      // PrimaryKeyID: 'Primary key ID',
      CustomerName: 'Customer Name',
      profitmargin: 'Profit Margin(%)',
      ShippingAddress: 'Shipping Address',
      Deliveryaddress: 'Delivery address',
      totalcost: 'Total Cost',
      Totalquotation: 'Total Quotation',
      CustomerTotalPrice: 'Customer total price',
      TotalDifference: 'Total difference',
      PercentageDifference: 'Percentage difference',
      CalculateTheTotal: 'Calculate the total',
      TotalNumberOfArticles: 'Total Requests',
      NumberOfCompletedItems: 'Completed Requests',
      pleaseNumber: 'please enter a number',
      PleaseUpload: 'Please upload',
      Fileupload: 'File upload',
      MultipleChoice: 'Multiple Selection',
      Selectfile: 'Select file',
    },
    tables: {
      NO: 'NO.',
      fileMode: 'Freight Calculator Template.xls',
      OrederNumber: 'Order Number',
      deliveryAddress: 'Delivery Address',
      Suburb: 'Country',
      State: 'State',
      Postcode: 'Postcode',
      Country: 'Suburb',
      SKUs: 'SKU',
      TotalWeight: 'TotalWeight',
      Length: 'Length(L)cm',
      width: 'Width(W)cm',
      Weight: 'Total Weight(kg)',
      Height: 'Height(H)cm',
      Qty: 'Qty(Q)',
      Volume: 'Volume(LxWxHxQ）',
      PiceFromCustomer: 'Price from Customer',

      inquiryList: 'Inquiry List',
      totalCost: 'Total  Cost',
      totalQuote: 'Total Quote',
      profitMargin: 'Profit Margin(%)',
      totalCustomPrice: 'Total Price from Customer',
      totalDiff: 'Total Difference',
      totalPercentage: 'Difference Percentage',

      bestPrice: 'Best Price',
      customerPrice: 'Price from Customer',
      provider: 'Best Courier Service',
      differPrice: 'Difference',
      diffPercentage: 'Difference Percentage',
      exclGST: '(excl. GST)'
    },
    TransitDetails: 'Transit Details',
    ConsignmentDetails: 'Consignment Details',
    // Calculate:"Calculate",
    DownloadPreview: 'Download Preview',
    chargeonyour: 'charge on your invoice',
    LogisticsService: 'Logistics Service Rate',
  },
  SendEmail: {
    notice: {
      title: 'Important Notice',
      acknowledgement: 'I have read and understood this notice and the attached document.',
    },
    table: {
      EmailTitle: 'Email Subject',
      SendingTime: 'Sending Time',
      SendEmail: "Sender's Email",
      EmailContent: 'Email Content',
      RequireConfirmation: 'Require Confirmation',
      Multiples: 'Attachments',
      EmailType: 'Email Type',
      Generalemail: 'General Email',
      BillingEmail: 'Billing Email',
      CustomerServiceEmail: 'Customer Service Email',
      NumberOfsuccessful: 'Number of Successful Sends',
      NameCustomer: 'Customers Who Failed to Receive',
    },
  },
  LogisticsRulesTable: {
    header: {
      No: 'No',
      Logistics: 'Logistics',
      Code: 'Code',
      FuelLevy: 'Fuel Levy',
      OversizedSurcharge: 'Oversized Surcharge',
      OverweightSurcharge: 'Overweight Surcharge',
      OtherSpecialRules: 'Other Special Rules',
      UpdateDate: 'Update Date'
    },
    OversizedSurchargeCol: {
      auS: 'Length must not exceed 105cm',
      auE: 'Length must not exceed 105cm',
      auI: 'Length must not exceed 105cm',
      alE: '',
      coP: 'Packages over 105cm incur a $15 fee, and cannot exceed 180cm.',
      diF: 'Packages 140-200cm: $8 fee; 200-300cm: $18 fee.',
      faA: 'Packages cannot exceed 200cm.',
      huE: 'Packages 120-150cm: $3 fee; 150-250cm: $10 fee.',
    },
    OverweightSurchargeCol: {
      auS: 'Must not exceed 22kg in actual weight or 62.5kg in cubic weight.',
      auE: 'Must not exceed 22kg in actual weight or 62.5kg in cubic weight.',
      auI: 'Must not exceed 22kg in actual weight or 62.5kg in cubic weight.',
      alE: '',
      coP: 'Must not exceed 25kg in actual weight or 40kg in cubic weight.',
      diF: 'Packages over 30kg incur a $7 fee, up to a maximum of $35.',
      faA: 'Must not exceed 25kg in actual weight or 40kg in cubic weight.',
      huE: 'Packages weighing 35-75kg: $10 fee; 75-100kg: $15 fee; over 100kg: $105 fee.',
    },
    OtherSpecialRulesCol: {
      auI: 'Only allows one package per order.',
      huE: 'WA fuel surcharge: 28%.',
    }
  }
};
